const ROUTES = {
  dashbaord: '/',
  createOrder: '/createOrder',
  orderDetails: '/orderDetails',
  login: '/login',
  resetPassword: '/resetPassword',
  setPassword: '/setPassword',
  sessionExpired: '/sessionExpired',
  onboarding: '/onboarding',
  newProfile: '/newProfile',
  profile: '/profile',
  allOrders: '/allOrders',
  siteMap: '/siteMap',
  jurisdictionCredentials: '/jurisdictionCredentials',
  recordingJurisdiction: '/recordingJurisdiction',
  allProjects: '/allProjects',
  newProject: '/newProject',
  projectDetails: '/projectDetails',
  mailer: '/mailer',
  composeEmail: '/composeEmail',
  emailSignature: '/emailSignature',
  bulkOrderCheck: '/bulkOrderCheck',
  rateCalculator: '/rateCalculator',
  people: '/people',
  teams: '/teams',
  allProfiles: '/allProfiles',
  documentTypeManagement: '/documentTypeManagement'
};

export default ROUTES;
